import { TranslatedCalling } from './common';

export const fetch_spark_instructions = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.fetch-spark-instructions.digging" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.fetch-spark-instructions.digging" />,
  result: () => null,
};
